// Light/dark theme, applied via `[data-theme]` on <html> (see src/app.css).
// index.html sets the attribute synchronously before first paint (same
// storage key/fallback logic duplicated there to avoid a flash); this module
// owns it from then on and lets the toggle persist a user choice.
const STORAGE_KEY = 'genba_theme';
export type Theme = 'light' | 'dark';

function systemTheme(): Theme {
  try {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
  } catch {
    return 'light';
  }
}

function initialTheme(): Theme {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch {
    /* localStorage unavailable — fall through to system preference */
  }
  return systemTheme();
}

class ThemeState {
  current = $state<Theme>(initialTheme());

  apply() {
    document.documentElement.setAttribute('data-theme', this.current);
    try {
      localStorage.setItem(STORAGE_KEY, this.current);
    } catch {
      /* best-effort persistence only */
    }
  }

  toggle() {
    this.current = this.current === 'dark' ? 'light' : 'dark';
    this.apply();
  }
}

export const theme = new ThemeState();
theme.apply();
